var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { i18n } from "@about-mink/info";
import styles from "./index.module.scss";
import yuzu1 from "./img/yuzu1.jpg";
import yuzu2 from "./img/yuzu2.jpg";
import yuzu3 from "./img/yuzu3.jpg";
import yuzu4 from "./img/yuzu4.jpg";
import yuzu5 from "./img/yuzu5.jpg";
import yuzu6 from "./img/yuzu6.jpg";
import yuzu7 from "./img/yuzu7.jpg";
export var Header = function () {
    var images = {
        col1: [
            yuzu1,
            yuzu2,
            yuzu3,
            yuzu4,
        ],
        col2: [
            yuzu5,
            yuzu6,
            yuzu7,
            yuzu1,
        ],
    };
    var getImage = function (src, key, translate) { return React.createElement("div", { className: styles.imageContainer, key: key, style: translate === true ? {
            position: "relative",
            top: "calc(-25% / ".concat(images.col2.length, ")"),
        } : {} },
        React.createElement("img", { src: src, alt: "" })); };
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.imagesContainer },
                React.createElement("div", { className: styles.images },
                    React.createElement("div", { className: styles.col1 }, __spreadArray(__spreadArray([], images.col1, true), images.col1, true).map(function (id, i) { return getImage(id, i); })),
                    React.createElement("div", { className: styles.col2 }, __spreadArray(__spreadArray([], images.col2, true), images.col2, true).map(function (id, i) { return getImage(id, i, true); }))),
                React.createElement("div", { className: styles.gradient })),
            React.createElement("div", { className: styles.textcontent },
                React.createElement("div", { className: styles.textContentInner },
                    React.createElement("h1", null,
                        "I make whatever you ",
                        React.createElement("span", { className: styles.ul }, "need"),
                        "."),
                    React.createElement("p", null, "Hey! This website is for demonstration purposes and I had no particular images to promote, so instead here's my dog. Isn't she cute?"),
                    React.createElement("a", { href: i18n.linkedin, target: "_blank", rel: "noreferrer" }, "I love it, work for me!")))),
        React.createElement("div", { className: styles.navbar },
            React.createElement("h2", null,
                React.createElement("span", { className: styles.overline }, "yu"),
                "zu"),
            React.createElement("div", { className: styles.rows },
                React.createElement("div", { className: styles.row1 },
                    React.createElement("span", { className: styles.contact },
                        React.createElement("a", { href: "mailto:".concat(i18n.mail), target: "_blank", rel: "noreferrer" }, "Email me"),
                        " or call ",
                        React.createElement("a", { href: "tel:".concat(i18n.phone.en.replace(/\D/g, "")) }, i18n.phone.en))),
                React.createElement("div", { className: styles.row2 },
                    React.createElement("a", { href: i18n.linkedin, target: "_blank", rel: "noreferrer" }, "Linked in"),
                    React.createElement("a", { href: i18n.resume.url.en, target: "_blank", rel: "noreferrer" }, "My Curriculum Vit\u00E6"),
                    React.createElement("a", { href: i18n.portfolio.en, target: "_blank", rel: "noreferrer" }, "My Portfolio")))));
};
